import { useSelector } from 'react-redux';
import { selectPhoneNumber } from 'views/CheckoutPage/selector';
import { rm } from 'utils';

interface OwnProps {
  className: string;
}
export const DisclaimerInfo = ({ className }: OwnProps) => {
  const phoneNumber = useSelector(selectPhoneNumber);

  return (
    <div className={className}>
      <p>{rm('checkout_contact_info_delivery_postbox_info', phoneNumber)}</p>
    </div>
  );
};
